<template>
  <div class="wrapper">
    <!-- <div @click="success_mask = true"  style="color: #fff; display: flex; align-items: center;">
      <i class="el-icon-switch-button" style="color: #fff;"></i>
      <span>退出登录</span>
    </div> -->
   
    <div>
      <el-dropdown>
        <div class="wrapper" style="display:flex;">
          <div class="box">
            <img class="img" :src="my_pic" />
          </div>
          <div class="name">
            <p class="font_16_black">{{user_name}}</p>
            <i class="el-icon-caret-bottom" style="color:"></i>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="navTo('User')">
            <!-- <i class="el-icon-user-solid"></i> -->
            我的账号
          </el-dropdown-item>
          <el-dropdown-item @click.native="success_mask = true">
            <!-- <i class="el-icon-switch-button"></i> -->
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 操作成功 -->
    <el-dialog :visible.sync="success_mask" width="18%" center @closed="handleDialogClosed" append-to-body
      modal-append-to-body>
      <h3 class="export-title font_16_black">
        <img style="margin-right: 10px" src="@/assets/icons/check002-E007@2x.png" alt="确认图标" />您将退出系统
      </h3>
      <span slot="footer" class="dialog-footer">
        <div class="save_btn">
          <button-a padding="0.5vw 5.4vw" color="#fff" bgcolor="#f26828" @click.native="handleLogout">确定</button-a>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Get } from "@/js/http.js";
import { getToken } from "@/js/tool.js";
const defaultAvatar = require('@/assets/header.png');
export default {
  data() {
    return {
      isHover: false,
      success_mask: false
    }
  },
  computed: {
    user_name() {
      return this.$store.state.user_name
    },
    user_pic() {
      return this.$store.state.user_pic
    },
     my_pic() {
      const pic = this.$store.state.my_pic;
      return (pic && pic.trim()) ? pic : defaultAvatar;
    }
  },
   mounted() {
    // 只有登录后才获取头像
    if (getToken()) {
      this.getPic();
    }
  },
  methods: {
     // 获取头像方法，用于上传头像后更新头像
    getPic() {
      Get(
        "api/v1/accounts/me/avatar",
        {}).then(res => {
          if(res.data){
            this.$store.commit("my_pic", `data:${res.msg};base64,${res.data}`);
          }else{
            this.$store.commit("my_pic", require('@/assets/header.png'));
          }
        }).catch(() => {
          this.$store.commit("my_pic", require('@/assets/header.png'));
        });
    },
    // 显示用户菜单
    hover(bool) {
      this.isHover = bool
    },
    navTo(name) {
      this.$router.push({
        name
      })
    },
    // 处理退出登录
    handleLogout() {
      // 先关闭弹窗
      this.success_mask = false
      // 微延迟确保弹窗关闭完成
      setTimeout(() => {
        this.performLogout()
      }, 100)
    },
    // 执行登出操作
    performLogout() {
      // 调用退出登录API
      Get('api/v1/auth/logout')
        .then(() => {
          // API调用成功后执行清理操作
          this.clearStorageAndRedirect()
        })
        .catch((error) => {
          console.error('退出登录API调用失败:', error)
          // API调用失败时仍然执行清理操作，确保用户可以退出
          this.clearStorageAndRedirect()
        })
    },
    // 向父项目发送退出登录消息
    notifyParentLogout() {
      // 如果是通过window.open打开的窗口，向opener发送消息
      if (window.opener) {
        try {
          window.opener.postMessage({ type: 'logout' }, '*')
          console.log('已向父窗口(opener)发送退出登录消息')
        } catch (e) {
          console.log('发送退出登录消息失败(opener):', e)
        }
      }
      // 如果在iframe中，向parent发送消息
      if (window.parent !== window) {
        try {
          window.parent.postMessage({ type: 'logout' }, '*')
          console.log('已向父项目(parent)发送退出登录消息')
        } catch (e) {
          console.log('发送退出登录消息失败(parent):', e)
        }
      }
    },
    
    // 清理存储并跳转到登录页
    clearStorageAndRedirect() {
      try {
        // 先发送退出登录消息，再清除存储
        this.notifyParentLogout()
        
        // 清除本地存储
        localStorage.clear()
        // 清除sessionStorage（包括登录成功标志）
        if (sessionStorage) {
          sessionStorage.clear()
        }
        // 提交登出mutation
        this.$store.commit('logout')
        this.$store.commit('cacheToggle', false)
        
        // 如果有opener（通过window.open打开的窗口），关闭窗口
        if (window.opener) {
          // 延迟关闭窗口，确保消息发送成功
          setTimeout(() => {
            window.close()
          }, 300)
          return
        } else if (window.parent !== window) {
          // 在iframe中，跳转回登录页
          this.$router.replace({
            name: 'Login',
            query: { t: Date.now() }
          })
        } else {
          // 独立运行时跳转到登录页
          this.$router.replace({
            name: 'Login',
            query: { t: Date.now() } // 防止页面缓存
          })
        }
      } catch (error) {
        console.error('登出失败:', error)
        // 出错时仍然跳转到登录页
        this.$router.replace({ name: 'Login' })
      }
    },
    // 弹窗完全关闭后的回调
    handleDialogClosed() {
      // 这里可以执行一些清理操作
    }
  }
}
</script>
<style lang="scss" scoped>
.name>p {
  color: #fff;
}

.avatar-box {
  overflow: hidden;
  width: 36px;
  height: 36px;
  margin-right: 13px;
  border-radius: 50%;
  border: 1px solid #ddd;
  cursor: pointer;

  .avatar {
    width: 36px;
    height: 36px;
  }
}

.wrapper {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 12px;
  margin-right: 14px;
  white-space: nowrap;
  overflow: visible;
  min-width: 80px;
  flex-shrink: 0;

  div {
    display: flex;
    align-items: center;
        cursor: pointer;
    // padding: 4px;
  }

  i {
    font-size: 18px;
    display: inline-block;
    color: #fff;
    margin-left: 5px;
  }

  .fade {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    // width: 100px;
    // height: 100px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 4px 4px 4px rgba(100, 100, 100, 0.1);

    // transition: all 0.5s ease;
    &.hidden {
      display: none;
      //   height: 0;
      //   transition: all 0.5s ease;
    }

  }

  @media screen and (max-width: 768px) {
    span {
      display: none;
    }

    min-width: 36px;
    margin-left: 8px;
    margin-right: 8px;

    div {
      padding: 4px;
    }
  }
}

.box {
  overflow: hidden;
  width: 42px;
  height: 42px;
  margin-right: 13px;
  border-radius: 50%;
 

  .img {
    width: 42px;
    height: 42px;
  }
}

.logout {
  cursor: pointer;
}

.menu-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 50px;

  &:hover {
    opacity: 0.7;
  }
}
</style>
